import "./App.css";
import "jquery";
import { Suspense } from "react";
import { Provider } from "react-redux";
import store from "./store";
import {
  Route,
  Routes,
  BrowserRouter as Router,
  Navigate,
} from "react-router-dom";
import Header from "./components/header/Header";
import Home from "./pages/Home/home";
// import HomeEN from "./pages/EN/Home/home";
// import ProductEN from "./pages/EN/Product/ProductDetails";
import ProductDetails from "./pages/Product/ProductDetails";
import VSATProductDetails from "./pages/Product/VSATProductDetails";
import NewsDetails from "./pages/Product/NewsDetails";
import NewsList from "./pages/Product/NewsList";
import Sitemap from "./pages/Sitemap/Sitemap";
// import AboutEN from "./pages/EN/About/AboutEN";
import About from "./pages/About/about";
import Retired from "./pages/Retired/Retired";
import RetiredAbout from "./pages/Retired/RetiredAbout";
import RetiredNewsList from "./pages/Retired/RetiredNewsList";
import CoWorkers from "./pages/About/coworker";
import Saham from "./pages/Saham/Saham";
import VSAT from "./pages/VSAT/VSAT";
import PreJob from "./pages/Jobs/pre-job";
import VSATAbout from "./pages/VSAT/VSATAbout";
import VSATProducts from "./pages/VSAT/VSATProducts";
import VSATNewsList from "./pages/VSAT/VSATNewsList";
import SahamNewsList from "./pages/Saham/SahamNewsList";
import Events from "./pages/About/events";
import SubCompany from "./pages/Saham/SubCompany";
import EventDetails from "./pages/About/event-details";
// import SitemapEN from "./pages/EN/Sitemap/SitemapEN";
import Search from "./pages/Search/Search";
import Landing from "./pages/Landing/Landing";
import TradeList from "./pages/Trade/Trade";
import FooterWrapper from "./components/FooterWrapper";
import NotFound from "./pages/errors/NotFound";
// import NotFoundEn from "./pages/errors/NotFoundEn";
import ScrollToTop from "./components/ScrollToTop";
import ProductList from "./pages/Product/ProductList";
import { Toaster } from "react-hot-toast";
const App = () => {
  return (
    <Provider store={store}>
      <Toaster />
      <Suspense>
        <Router>
          <Header />
          <div id="main-content">
            <ScrollToTop />
            <Routes>
              <Route exact path="/" element={<Home />} />
              <Route exact path="/job/intro" element={<PreJob />} />

              <Route exact path="/trade/list" element={<TradeList />} />
              <Route exact path="/news/list" element={<NewsList />} />
              <Route exact path="/about" element={<About />} />
              <Route exact path="/events" element={<Events />} />
              <Route exact path="/events/:id" element={<EventDetails />} />
              <Route exact path="/coworkers" element={<CoWorkers />} />
              <Route
                exact
                path="/product/show/:id"
                element={<ProductDetails />}
              />
              {/* <Route exact path="/product/list" element={<ProductList />} /> */}
              {/* <Route
                exact
                path="/vsat/product/show/:id"
                element={<VSATProductDetails />}
              /> */}
              <Route exact path="/news/show/:id" element={<NewsDetails />} />
              <Route
                exact
                path="/retired/news/show/:id"
                element={<NewsDetails />}
              />
              <Route
                exact
                path="/partners/news/show/:id"
                element={<NewsDetails />}
              />
              {/* <Route
                exact
                path="/vsat/news/show/:id"
                element={<NewsDetails />}
              /> */}
              <Route exact path="/search" element={<Search />} />
              <Route exact path="/partners" element={<Saham />} />
              {/* <Route exact path="/vsat" element={<VSAT />} />
              <Route exact path="/vsat/about" element={<VSATAbout />} />
              <Route exact path="/vsat/products" element={<VSATProducts />} /> */}
              <Route exact path="/retired" element={<Retired />} />
              <Route exact path="/retired/about" element={<RetiredAbout />} />
              <Route
                exact
                path="/retired/news/list"
                element={<RetiredNewsList />}
              />
              {/* <Route exact path="/vsat/news/list" element={<VSATNewsList />} /> */}
              <Route exact path="/sitemap" element={<Sitemap />} />
              <Route
                exact
                path="/partners/news/list"
                element={<SahamNewsList />}
              />
              <Route
                exact
                path="/partners/companies"
                element={<SubCompany />}
              />
              <Route exact path="/landing/:id" element={<Landing />} />
              {/* 
                <Route exact path="/en" element={<HomeEN/>} />
                <Route exact path="/en/about" element={<AboutEN/>} />
                <Route exact path="/en/sitemap" element={<SitemapEN/>} />
                <Route exact path="/en/product/show/:id" element={<ProductEN/>} />
                <Route exact path="/en/404" element={<NotFoundEn/>} />
                <Redirect from="/en/*" to="/en/404" />
              */}

              <Route path="/404" element={<NotFound />} />
              <Route path="*" element={<Navigate to={"/404"} replace />} />
            </Routes>
            <FooterWrapper />
          </div>
        </Router>
      </Suspense>
    </Provider>
  );
};

export default App;
